<template>
  <v-container>
    <!-- Label -->
    <v-row>
      <v-col>
        <h2>
          <v-icon v-if="!updateMode">mdi-book</v-icon>
          <v-icon v-else>icon-edit-class</v-icon>
          <span class="ml-4 font-weight-regular" v-if="!updateMode">Crea tu clase</span>
          <span class="ml-4 font-weight-regular" v-else>Editar Clase</span>
        </h2>
      </v-col>
    </v-row>

    <!-- General Information -->
    <v-row>
      <v-col>
        <v-text-field name="classTitle" label="Título" outlined rounded id="title" v-model="title"></v-text-field>
      </v-col>
      <v-col>
        <v-text-field
          name="classCode"
          label="Código *"
          :rules="requiredRules"
          outlined
          rounded
          id="id"
          v-model="code"
        ></v-text-field>
      </v-col>
      <v-col cols="1">
        <v-checkbox label="Pie" v-model="pie" :value="pie"></v-checkbox>
      </v-col>
    </v-row>

    <!-- Description -->

    <!-- tiptap -->
    <v-row>
      <v-col cols="12">
        <TipTap placeholder="Descripcion *" />
      </v-col>
      <!-- <v-col cols="12" v-if="editorIsEmpty">
        <div class="v-messages theme--light error--text" role="alert">
          <div class="v-messages__wrapper">
            <div class="v-messages__message">Este campo es requerido</div>
          </div>
        </div>
      </v-col>-->
    </v-row>

    <!-- Subjects -->
    <v-row>
      <v-col cols="12">
        <h3 class="font-weight-regular">Asignar a asignatura y nivel</h3>
      </v-col>
      <v-col>
        <v-select
          v-model="subject"
          :items="subjects"
          label="Asignatura *"
          outlined
          rounded
          :rules="requiredRules"
        ></v-select>
      </v-col>
      <v-col>
        <v-select
          v-model="level"
          :items="levels"
          label="Nivel *"
          outlined
          rounded
          :rules="requiredRules"
        ></v-select>
      </v-col>
      <v-col>
        <v-select
          v-model="cource"
          :items="cources"
          label="Curso *"
          outlined
          rounded
          :rules="requiredRules"
        ></v-select>
      </v-col>
      <v-col>
        <v-select
          v-model="unit"
          :items="units"
          label="Unidad *"
          outlined
          rounded
          :rules="requiredRules"
        ></v-select>
      </v-col>
    </v-row>

    <!-- Planification -->
    <v-row>
      <v-col cols="12">
        <h3 class="font-weight-regular">Asignar a planición</h3>
      </v-col>
      <v-col>
        <v-select
          v-model="planUnit"
          :items="plans"
          label="Plan de Unidad *"
          outlined
          rounded
          :rules="requiredRules"
        ></v-select>
      </v-col>
      <v-col>
        <v-select
          v-model="activity"
          :items="activities"
          label="Actividad *"
          outlined
          rounded
          :rules="requiredRules"
        ></v-select>
      </v-col>
      <v-col>
        <v-select
          v-model="week"
          :items="weeks"
          label="Semana *"
          outlined
          rounded
          :rules="requiredRules"
        ></v-select>
      </v-col>
    </v-row>

    <!-- submit -->
    <v-row class="justify-center">
      <v-dialog v-model="dialog" persistent max-width="290">
        <template v-slot:activator="{ on, attrs }">
          <v-btn rounded color="accent" large v-bind="attrs" v-on="on" :disabled="!avalibleSubmit">
            <span class="text-capitalize mr-4">Guardar</span>
            <v-icon>mdi-content-save</v-icon>
          </v-btn>
        </template>
        <v-card>
          <v-card-text class="text-center pt-5 font-w">¿Desea Continuar?</v-card-text>
          <v-card-actions>
            <v-spacer></v-spacer>
            <v-btn color="red" text @click="toggleModal()">No</v-btn>
            <v-btn color="green" text @click="createNewLesson()">si</v-btn>
          </v-card-actions>
        </v-card>
      </v-dialog>
    </v-row>
  </v-container>
</template>

<script>
import TipTap from "@/components/commons/RomaTipTap";
import { mapActions } from "vuex";
import {
  TiptapVuetify,
  Heading,
  Bold,
  Italic,
  Strike,
  Underline,
  Code,
  Paragraph,
  BulletList,
  OrderedList,
  ListItem,
  Link,
  Blockquote,
  HardBreak,
  HorizontalRule,
  History
} from "tiptap-vuetify";
export default {
  props: ["updateMode"],
  components: { TipTap },
  data() {
    return {
      title: "",
      code: "",
      pie: false,
      description: ``,
      subject: "",
      level: "",
      cource: "",
      unit: "",
      planUnit: "",
      activity: "",
      week: "",
      subjects: ["Matemática", "Historia", "Literatura", "Música"],
      levels: ["Nivel 1", "Nivel 2", "Nivel 3", "Nivel 4"],
      cources: ["Curso 1", "Curso 2", "Curso 3", "Curso 4"],
      units: ["Unidad 1", "Unidad 2", "Unidad 3", "Unidad 4"],
      plans: ["Plan 1", "Plan 2", "Plan 3", "Plan 4"],
      activities: ["Actividad 1", "Actividad 2", "Actividad 3", "Actividad 4"],
      weeks: ["Weeks 1", "Weeks 2", "Weeks 3", "Weeks 4"],
      dialog: false,

      // validations
      requiredRules: [v => !!v || "Este campo es requerido"],
      editorIsEmpty: false
    };
  },
  computed: {
    avalibleSubmit() {
      const avalibleSubmit =
        !!this.code &&
        !!this.description &&
        !!this.subject &&
        !!this.level &&
        !!this.cource &&
        !!this.unit &&
        !!this.planUnit &&
        !!this.activity &&
        !!this.week;
      return avalibleSubmit;
    }
  },
  methods: {
    isEmpty() {
      console.info(!!this.description);
      this.editorIsEmpty =
        (this.description === "") | (this.description === "<p></p>")
          ? true
          : false;
    },
    ...mapActions({
      addNewLesson: "addNewLesson"
    }),
    createNewLesson() {
      const newLesson = {
        title: this.title,
        subject: this.subject,
        unit: this.unit,
        lesson: "lección by default",
        date: "20/12/2020",
        pie: this.pie,
        status: "Iniciando",
        progress: {
          img: "http://placehold.it/100",
          currentProgress: 0
        }
      };
      this.addNewLesson(newLesson);
    },
    toggleModal() {
      this.dialog = !this.dialog;
    }
  }
};
</script>
<style lang="scss">
.icon-edit-class:before {
  content: url("../../assets/icons/create-class-icon.svg");
  width: 32px;
  margin-left: 10px;
}
</style>
